function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhilosophy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 42 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.728,32.746C31.573,32.746 40.363,25.606 40.363,16.793C40.363,7.98 31.573,0.839 20.728,0.839C9.882,0.839 1.092,7.98 1.092,16.793C1.092,20.252 2.45,23.45 4.751,26.066C4.605,27.945 3.877,29.617 3.11,30.89C2.688,31.596 2.258,32.164 1.944,32.547C1.783,32.739 1.66,32.885 1.568,32.984C1.522,33.03 1.491,33.069 1.468,33.092L1.445,33.115C1.092,33.467 0.993,33.989 1.184,34.449C1.376,34.909 1.821,35.209 2.32,35.209C4.521,35.209 6.738,34.526 8.578,33.728C10.335,32.961 11.83,32.049 12.743,31.381C15.182,32.263 17.882,32.754 20.728,32.754L20.728,32.746ZM10.91,19.247C9.552,19.247 8.456,18.15 8.456,16.793C8.456,15.435 9.552,14.338 10.91,14.338C12.268,14.338 13.364,15.435 13.364,16.793C13.364,18.15 12.268,19.247 10.91,19.247ZM20.728,19.247C19.37,19.247 18.273,18.15 18.273,16.793C18.273,15.435 19.37,14.338 20.728,14.338C22.085,14.338 23.182,15.435 23.182,16.793C23.182,18.15 22.085,19.247 20.728,19.247ZM33,16.793C33,18.15 31.903,19.247 30.545,19.247C29.188,19.247 28.091,18.15 28.091,16.793C28.091,15.435 29.188,14.338 30.545,14.338C31.903,14.338 33,15.435 33,16.793Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhilosophy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/philosophy.8ad2fe4297f22fbd7e35e1dc50627952.svg";